import * as React from 'react';
import clsx from 'clsx';
import { Interactive } from '../Base';
import Svg from '../Svg';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "DropDownMenuItem-root_1wWxI",
  "icon": "DropDownMenuItem-icon_3t5OJ",
  "intentDefault": "DropDownMenuItem-intentDefault_k6bVa",
  "intentDanger": "DropDownMenuItem-intentDanger_30B0R",
  "disabled": "DropDownMenuItem-disabled_AhJUs"
};
const DropDownMenuItem = /*#__PURE__*/React.forwardRef(({
  type = 'button',
  icon,
  intent,
  disabled,
  children,
  className,
  ...extraProps
}, ref) => /*#__PURE__*/_jsxs(Interactive, {
  tabIndex: "-1",
  "aria-disabled": disabled,
  disabled: disabled,
  innerRef: ref,
  type: type,
  flex: true,
  flexAlignItemsCenter: true,
  boxSizing: "border",
  hoverable: true,
  interactive: true,
  size: "base",
  weight: "regular",
  align: "start",
  backgroundColor: "transparent",
  className: clsx(styles.root, {
    [styles.intentDefault]: !intent,
    [styles.intentDanger]: intent === 'danger',
    [styles.disabled]: disabled
  }, className),
  ...extraProps,
  children: [icon && Svg.has(icon) && /*#__PURE__*/_jsx(Svg, {
    name: icon,
    theme: disabled ? 'grey' : intent === 'danger' ? 'danger' : 'green',
    className: styles.icon
  }), children]
}));
DropDownMenuItem.displayName = 'DropDownMenuItem';
export default DropDownMenuItem;